import React from 'react';
import Styles from './PartiuGpCalendario.css';
import ContainerHome24 from '@/components/atoms/ContainerHome24';
import CustomEmblaCarouselHome24 from '@/components/organisms/CustomEmblaCarouselHome24';
import { useLayout } from '@/utils/useLayout';

const etapas = [
  {
    numero: 1,
    titulo: 'Elegibilidade de contratação',
    texto: 'Período para financiar seu carro ou moto',
    data: '01/10 a 30/11/2026',
  },
  {
    numero: 2,
    titulo: 'Aceite da campanha',
    texto: 'Confirme sua participação na promoção',
    data: '01/10 a 31/12/2026',
  },
  {
    numero: 3,
    titulo: 'Consulta dos números da sorte',
    texto: 'Veja os números da sorte conquistados',
    data: 'A partir de 02/02/2027',
  },
  {
    numero: 4,
    titulo: 'Sorteio',
    texto: 'Apuração dos números da sorte',
    data: '03/02/2027',
  },
  {
    numero: 5,
    titulo: 'Divulgação do ganhador',
    texto: 'Resultado final da promoção',
    data: 'A partir de 05/03/2027',
  },
];

function Slide({ etapa, className }) {
  return (
    <div className={`slide ${className || ''}`}>
      <span className="slide-numero">{etapa.numero}</span>
      <h3 className="slide-titulo">{etapa.titulo}</h3>
      <p className="slide-texto">{etapa.texto}</p>
      <span className="slide-data">{etapa.data}</span>
    </div>
  );
}

function PartiuGpCalendario() {
  const { width } = useLayout();
  const isDesktop = width >= 992;

  return (
    <section id="partiu-gp-calendario">
      <ContainerHome24>
        <p className="calendario-eyebrow">Calendário</p>
        <h2 className="calendario-titulo">Acompanhe cada etapa da promoção</h2>

        {isDesktop ? (
          <div className="calendario-cards">
            {etapas.map((etapa) => (
              <Slide etapa={etapa} key={etapa.numero} />
            ))}
          </div>
        ) : (
          <div className="calendario-carrossel">
            <CustomEmblaCarouselHome24 enableBullets detectBulletCount>
              {({ className }) =>
                etapas.map((etapa) => (
                  <Slide etapa={etapa} className={className} key={etapa.numero} />
                ))
              }
            </CustomEmblaCarouselHome24>
          </div>
        )}
      </ContainerHome24>
      <style jsx>{Styles}</style>
    </section>
  );
}

export default PartiuGpCalendario;
